import { render, staticRenderFns } from "./AnalyticsDetail.vue?vue&type=template&id=45192981&scoped=true&"
import script from "./AnalyticsDetail.vue?vue&type=script&lang=js&"
export * from "./AnalyticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsDetail.vue?vue&type=style&index=0&id=45192981&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45192981",
  null
  
)

export default component.exports